import Vue from "vue";
import { magicMouse } from "magicmouse.js";

Vue.prototype.$magicMouse = magicMouse;
